import { render, staticRenderFns } from "./IntegrationFailedAttemptsListItemMessageModal.vue?vue&type=template&id=5162a3f0&scoped=true"
import script from "./IntegrationFailedAttemptsListItemMessageModal.vue?vue&type=script&lang=js"
export * from "./IntegrationFailedAttemptsListItemMessageModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFailedAttemptsListItemMessageModal.vue?vue&type=style&index=0&id=5162a3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162a3f0",
  null
  
)

export default component.exports